var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 259,
    viewBox: "0 0 61 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5381 9.61222C41.4594 4.4127 45.6347 0.00109672 50.913 0.00109672C56.1125 -0.0776839 60.5242 4.09759 60.5242 9.37589C60.6029 14.5754 56.4276 18.9871 51.1493 18.9871C45.9498 19.0659 41.5381 14.8905 41.5381 9.61222ZM54.2094 34.3217H47.0889V43.8158H54.2094V34.3217ZM54.2122 166.907H47.0916V178.3V181.053C47.0916 182.003 47.0916 183.095 47.0441 184.424L54.1647 184.614C54.1647 183.861 54.1789 183.152 54.1918 182.508C54.2024 181.973 54.2122 181.484 54.2122 181.053V178.158V166.954V166.907ZM47.0889 61.3803H54.2094V78.9919H47.0889V61.3803ZM41.537 218.033L48.2779 220.264C50.0817 214.853 51.5059 208.919 52.5027 202.605L45.4771 201.466C44.5277 207.4 43.1985 212.954 41.537 217.986V218.033ZM47.0889 131.732H54.2094V149.343H47.0889V131.732ZM54.2094 96.5555H47.0889V114.167H54.2094V96.5555ZM27.5823 250.693L23.4524 244.901C27.6298 241.958 31.3325 237.97 34.4656 233.128L40.4468 236.973C36.7916 242.575 32.4718 247.18 27.5823 250.693ZM0 251.927V259C3.51282 259 6.9307 258.668 10.1112 258.098L8.78205 251.12C6.02876 251.642 3.03812 251.927 0 251.927Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerJ);
export default __webpack_public_path__ + "static/media/LOWER_J.5cf04862eff784ec664dbd6ce23a15d3.svg";
export { ForwardRef as ReactComponent };